import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

class StateSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selection: '',
      options: [],
    };

    this.stateSelected = this.stateSelected.bind(this);
    this.redirectToStatePage = this.redirectToStatePage.bind(this);
  }

  valid() {
    return this.state.selection && this.state.selection !== '';
  }

  componentDidMount() {
    const states = this.loadStates();
    const options = states.map((option) => {
      return { label: option.name, value: option.slug };
    });

    this.setState({
      options,
    });
  }

  loadStates() {
    const statesJson = document.getElementById('state-search').getAttribute('data-states');
    return JSON.parse(statesJson);
  }

  stateSelected(selectedState) {
    const value = selectedState ? selectedState.value : '';

    this.setState({
      selection: value,
    });
  }

  redirectToStatePage(e) {
    e.preventDefault();

    window.location.assign(`/marriage-laws/${ this.state.selection }`);
  }

  renderArrow(_) {
    return '';
  }

  render() {
    return(
      <div classNme='state-search-container'>
        <Select
          searchable
          name='state'
          placeholder='Enter Your State'
          onChange={ this.stateSelected }
          options={ this.state.options }
          value={ this.state.selection }
          arrowRenderer={ this.renderArrow }
          className='search-box'
        />

        <button disabled={ !this.valid() } onClick={ this.redirectToStatePage } className='cta-square search-button'>
          Search
        </button>
      </div>
    );
  }
}

StateSearch.propTypes = {
};

export default StateSearch;
